import axios from 'axios';
import _ from 'lodash';
import url from '../../config/server.js';
import {
  skipPage,
  remindNativeRefreshJSMethod
} from '@/utils/common';
axios.defaults.headers.common['Content-Type'] =
  'application/json;charset=UTF-8';
// 创建axios实例
const service = axios.create({
  timeout: 10000, // 请求超时时间
  contentType: 'application/json;charset=UTF-8',
  responseType: 'json',
  method: 'post',
  url: url,
  withCredentials: false // 是否允许带cookie这些
});
service.defaults.headers.post['Content-Type'] =
  'application/json;charset=UTF-8';

// request拦截器
service.interceptors.request.use(
  config => {
    let accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      remindNativeRefreshJSMethod('300');
      dsBridge.register('getPlatformToken', data => {
        let useMsg = JSON.parse(decodeURIComponent(data));
        if (!useMsg.accessToken) { //用户第一次未登录
          skipPage(100);
        } else {
          localStorage.setItem('accessToken', useMsg.accessToken);
          localStorage.setItem('platformType', 'h5-' + useMsg.platformType);
        }
      })
    }



    return config;
  },
  error => {
    console.log(error); // for debug
    Promise.reject(error);
  }
);
// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * 通过response自定义status来标示请求状态
     * status为非20000是抛错 可结合自己业务进行修改
     */
    const res = response.data;
    if (res.code !== '0') {
      if (res.code === '-101') {
        localStorage.removeItem('accessToken');
      }
      if (_.get(res, 'msg')) {
        return res;
      }
      return Promise.reject('error');
    } else {
      return res;
    }
  },
  error => {
    console.log('err' + error); // for debug
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js